import AbstractController from '../../../../../vendors/services/abstractController';
import EventoService from '../../../../services/evento.service';
import {useState} from 'react';

export default class DegravacaoController extends AbstractController {

  private eventoService: EventoService;
  public lista: any;
  public setLista: any;

  constructor() {
    super();
    [this.lista, this.setLista] = useState([]);
    this.eventoService = new EventoService();
  }

  obterDegravacao(cdContribuicao: any) {
    this.start();
    this.eventoService.getDegravacao(cdContribuicao).then((res: any) => {
      this.stop();
      if (!!res.result && res.result.length > 0) {
        this.setLista(res.result);
      }
    }).catch(err => this.stop());
  }

}
